<template>
    <div class="bloque-general">
        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <div class="bloque-general__encabezado">
                        <h2>Trámites y Servicios en línea</h2>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-6 col-md-3">
                    <a href="https://pagopredial.santiago.gob.mx/" class="item-tramite-servicio">
                        <div class="item-tramite-servicio__icono">
                            <img src="/img/icono-tys-predial.png" alt="Pago del predial" loading="lazy" width="85" height="77">
                            <img class="active" src="/img/icono-tys-predial-active.png" alt="Pago del predial" loading="lazy" width="85" height="77">
                        </div>
                        <div class="item-tramite-servicio__nombre">Pago del predial</div>
                    </a>
                </div>
                <div class="col-sm-6 col-md-3">
                    <a href="https://pagotransito.santiago.gob.mx/" class="item-tramite-servicio">
                        <div class="item-tramite-servicio__icono">
                            <img src="/img/icono-tys-licencia.png" alt="Pago de multas de tránsito" loading="lazy" width="85" height="77">
                            <img class="active" src="/img/icono-tys-licencia-active.png" alt="Pago de multas de tránsito" loading="lazy" width="85" height="77">
                        </div>
                        <div class="item-tramite-servicio__nombre">Pago de multas de tránsito</div>
                    </a>
                </div>

                <div class="col-sm-6 col-md-3">
                    <a href="https://bolsadetrabajo.santiago.gob.mx" class="item-tramite-servicio">
                        <div class="item-tramite-servicio__icono">
                            <img src="/img/servicios/bolsa-trabajo-on.png" alt="" loading="lazy" width="85" height="77">
                            <img class="active" src="/img/servicios/bolsa-trabajo-over.png" alt="" loading="lazy" width="85" height="77">
                        </div>
                        <div class="item-tramite-servicio__nombre">Bolsa de Empleo</div>
                    </a>
                </div>

                <div class="col-sm-6 col-md-3">
                    <a href="/servicio/protesta-ciudadana" class="item-tramite-servicio">
                        <div class="item-tramite-servicio__icono">
                            <img src="/img/servicios/protesta-on.png" alt="" loading="lazy" width="85" height="77">
                            <img class="active" src="/img/servicios/protesta-over.png" alt="" loading="lazy" width="85" height="77">
                        </div>
                        <div class="item-tramite-servicio__nombre">Protesta Ciudadana</div>
                    </a>
                </div>

                <div class="col-sm-6 col-md-3">
                    <a href="/servicio/solicitud-de-registro-al-padron-de-proveedores" class="item-tramite-servicio">
                        <div class="item-tramite-servicio__icono">
                            <img src="/img/servicios/proveedor-on.png" alt="" loading="lazy" width="85" height="77">
                            <img class="active" src="/img/servicios/proveedor-over.png" alt="" loading="lazy" width="85" height="77">
                        </div>
                        <div class="item-tramite-servicio__nombre">Solicitud de Registro al Padrón de Proveedores</div>
                    </a>
                </div>

                <div class="col-sm-6 col-md-3">
                    <a href="/servicio/permiso-de-salubridad" class="item-tramite-servicio">
                        <div class="item-tramite-servicio__icono">
                            <img src="/img/servicios/salubridad-on.png" alt="" loading="lazy" width="85" height="77">
                            <img class="active" src="/img/servicios/salubridad-over.png" alt="" loading="lazy" width="85" height="77">
                        </div>
                        <div class="item-tramite-servicio__nombre">Permiso de Salubridad</div>
                    </a>
                </div>

                <div class="col-sm-6 col-md-3">
                    <a href="http://revalidacionanuencia.santiago.gob.mx" class="item-tramite-servicio">
                        <div class="item-tramite-servicio__icono">
                            <img src="/img/servicios/anuencia-on.png" alt="" loading="lazy" width="85" height="77">
                            <img class="active" src="/img/servicios/anuencia-over.png" alt="" loading="lazy" width="85" height="77">
                        </div>
                        <div class="item-tramite-servicio__nombre">Pago de revalidación de anuencia municipal</div>
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {

}
</script>
<style></style>
